import React from "react";
import Empty from "antd/es/empty";

import "./infotable.scss";

export default function InfoTable({
  titles,
  info,
  keys, // optional ordered keys to map values
  showColon,
  outlined,
  transparent,
}) {
  return (
    <div className={`toolBox ${outlined && "outline"}`}>
      {info ? (
        <table>
          <tbody>
            {(keys && keys.length ? keys : Object.keys(info || {}))?.map(
              (key, index) => {
                const value = info?.[key];
                const isNullish =
                  value === undefined ||
                  value === null ||
                  value === "" ||
                  (typeof value === "string" &&
                    (value.trim() === "" ||
                      value.trim().toLowerCase() === "null"));
                if (isNullish && !titles) return null;
                const displayValue = isNullish ? "-" : value;
                return (
                  <tr key={index}>
                    {titles && (
                      <td className={"toolDescription"}>{titles[index] || ""}</td>
                    )}
                    {titles && showColon && <td>:</td>}
                    <td>{displayValue}</td>
                  </tr>
                );
              }
            )}
          </tbody>
        </table>
      ) : (
        <Empty />
      )}
    </div>
  );
}
